import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import { Food } from '../../../models/tracks/food';
import Button from "../../components/Button";
import Select from "../../components/Select";

type Props = {
  item: Food;
  onAdd: (item: Food, measureValue: number, measureOption: string) => void;
};

const ServingPage = (props: Props) => {
  const [offsetTop, setOffsetTop] = useState<number>(0);

  const [measureOptions, setMeasureOptions] = useState<{key: string, value: string}[]>([])
  const [measureOption, setMeasureOption] = useState<string>('Gram')
  const [lastMeasureWeight, setLastMeasureWeight] = useState<number>(1)
  const [measureValue, setMeasureValue] = useState<number>(100)

  const ref = useRef<HTMLDivElement>();
  useEffect(() => {
    setOffsetTop(ref.current.offsetTop);
  }, []);

  useEffect(() => {
    setMeasureOptions(props.item.measures.map((measure) => {
      return {key: measure.label, value: measure.label}
    }))
  }, []);

  useEffect(() => {
    const measure = props.item.measures.find((item) => item.label.toLowerCase() === measureOption.toLowerCase())
    const value = measureValue * lastMeasureWeight / measure.weight
    setMeasureValue(+value.toFixed(2))
    setLastMeasureWeight(measure.weight)
  }, [measureOption]);

  const measure = props.item.measures.find((item) => item.label.toLowerCase() === measureOption.toLowerCase())

  return (
    <div
      className={styles.body}
      ref={ref}
      style={{ height: `calc(100vh - ${offsetTop + 50}px)` }}
    >
      <div className={styles.add_item}>
        <div className={styles.item}>
          <div className={styles.column}/>
          <div className={styles.column}>
            <div className={styles.meal_name}>{props.item.food.label}</div>
            <div className={styles.meal_measure}>100 g</div>
          </div>
          <div className={styles.column}>{props.item.food.calculateNutrient('FAT', measure.weight, measureValue)}</div>
          <div className={styles.column}>{props.item.food.calculateNutrient('CHOCDF', measure.weight, measureValue)}</div>
          <div className={styles.column}>{props.item.food.calculateNutrient('PROCNT', measure.weight, measureValue)}</div>
          <div className={styles.column}>
            {props.item.food.calculateNutrient('ENERC_KCAL', measure.weight, measureValue)}
          </div>
          <div className={styles.column} />
        </div>
        <div className={styles.serving}>
          Serving size
        </div>
        <div className={styles.serving_form}>
          <div className={styles.count}>
            <input step={0.01} min={0.1} type="number" value={measureValue} onChange={(e) => {
              setMeasureValue(parseFloat(e.target.value))
            }} />
          </div>
          <div className={styles.measure}><Select options={measureOptions} selected={measureOption} onSelect={(option) => {
            setMeasureOption(option)
          }} /></div>
        </div>
      </div>
      <Button type={'success'} onClick={() => props.onAdd(props.item, measureValue, measureOption)} >Add</Button>
    </div>
  );
};
export default ServingPage;
